import React from 'react';
import styles from './Nav.module.css';

export default function Nav({ children, className = '', ...rest }) {
  return (
    <nav className={`${styles.nav} ${className}`} {...rest}>
      {children}
    </nav>
  );
}

Nav.Link = function NavLink({ children, active = false, disabled = false, onClick, as: As = 'button', className = '', ...rest }) {
  const Component = As;
  return (
    <Component
      className={`${styles.link} ${active ? styles.active : ''} ${disabled ? styles.disabled : ''} ${className}`}
      onClick={disabled ? undefined : onClick}
      disabled={disabled}
      {...rest}
    >
      {children}
    </Component>
  );
};

Nav.Item = function NavItem({ children, className = '', ...rest }) {
  return (
    <div className={`${styles.item} ${className}`} {...rest}>
      {children}
    </div>
  );
};
